'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of supplement resources
 */ const SupplementResources = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M62.1803 17.9761L26.8827 24.501C24.3463 24.9698 22.6628 27.4155 23.1318 29.953L32.2894 79.4925C32.7584 82.03 35.205 83.7123 37.7415 83.2434L73.039 76.7185C75.5765 76.2494 77.2588 73.8029 76.7899 71.2664L67.6323 21.727C67.1633 19.1895 64.7167 17.5072 62.1803 17.9761Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M72.9027 27.0918H37.0559C34.4799 27.0918 32.3828 29.1926 32.3828 31.7753V82.1978C32.3828 84.7805 34.4799 86.8813 37.0559 86.8813H72.9027C75.4797 86.8813 77.5758 84.7795 77.5758 82.1978V31.7753C77.5758 29.1926 75.4787 27.0918 72.9027 27.0918Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "55.4531",
                y: "40.2324",
                width: "16",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.4531",
                y: "64.2324",
                width: "33",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "55.4531",
                y: "52.2324",
                width: "16",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.4531",
                y: "77.2324",
                width: "33",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "55.4531",
                y: "34.2324",
                width: "16",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.4531",
                y: "58.2324",
                width: "33",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "55.4531",
                y: "46.2324",
                width: "16",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.4531",
                y: "70.2324",
                width: "33",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M49.1647 39.9989V38.352H49.5978C50.0134 38.352 50.3504 38.015 50.3504 37.5993V35.987C50.3504 35.5713 50.0134 35.2344 49.5978 35.2344H40.2368C39.8211 35.2344 39.4842 35.5713 39.4842 35.987V37.5993C39.4842 38.015 39.8211 38.352 40.2368 38.352H40.6699V40.0232C40.0193 40.2608 39.4582 40.6883 39.0619 41.2481C38.6657 41.808 38.4533 42.4736 38.4531 43.1555V54.2822C38.4531 54.6978 38.7901 55.0348 39.2058 55.0348H50.7005C51.1162 55.0348 51.4531 54.6978 51.4531 54.2822V43.157C51.4531 42.4622 51.2327 41.7847 50.8226 41.2187C50.4124 40.6527 49.833 40.2264 49.1647 39.9989Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "39.4023",
                y: "35.2324",
                width: "10.922",
                height: "3.12059",
                rx: "0.518223",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.SupplementResources = SupplementResources;
//# sourceMappingURL=SupplementResources.cjs.map
